/**
 * Single source of truth: provider slug → genuine brand-mark filename under the
 * app's `/public/brand-logos/` (served statically by the Next shell).
 *
 * Consumed by BOTH provider-logo surfaces so they can never drift apart again:
 *   • Integrations marketplace — `excellent/src/integrations/provider-logo.tsx`
 *     (catalog in `excellent/src/integrations/catalog-meta.ts`)
 *   • Marketing Analytics blocks — `blocks/marketing/provider-logo.tsx`
 *     (catalog `ANALYTICS_PROVIDER_CATALOG` in that file)
 *
 * Every file is a real brand mark — full-color SVG from dashboard-icons /
 * gilbarbara, monochrome simple-icons tinted to brand color (their letter
 * counters are negative space, so the tinted disc reads as the genuine mark on
 * the white logo chip), or a vendor's own PNG where no open SVG exists.
 * Refresh/extend every mark with `scripts/fetch-brand-logos.sh`.
 */
export const BRAND_LOGO_FILES: Record<string, string> = {
  // ── Integrations marketplace (catalog-meta.ts) ──
  hubspot: "hubspot.svg",
  salesforce: "salesforce.svg",
  pipedrive: "pipedrive.svg",
  "google-mail": "google-mail.svg",
  "google-calendar": "google-calendar.svg",
  "google-contacts": "google-contacts.svg",
  greenhouse: "greenhouse.svg",
  lever: "lever.png",
  ashby: "ashby.png",
  notion: "notion.svg",
  "google-drive": "google-drive.svg",
  github: "github.svg",
  slack: "slack.svg",
  stripe: "stripe.svg",
  xero: "xero.svg",
  quickbooks: "quickbooks.svg",
  ga4: "ga4.svg",
  gsc: "gsc.svg",
  plausible: "plausible.svg",
  posthog: "posthog.svg",
  supabase: "supabase.svg",
  postgrest: "postgrest.svg",
  // ── Marketing Analytics catalog extras (ANALYTICS_PROVIDER_CATALOG) ──
  fathom: "fathom.svg",
  umami: "umami.svg",
  vercel: "vercel.svg",
  matomo: "matomo.svg",
  // ── Department-coverage providers (seed v7) ──
  // plaid + docusign have no open-collection SVG (dashboard-icons/simple-icons
  // 404), so their marks come from the vendors' own sites (like ashby/lever):
  // plaid.com's safari-pinned-tab.svg vector mark + docusign.com's 180×180 icon.
  shopify: "shopify.svg",
  linear: "linear.svg",
  figma: "figma.svg",
  mailchimp: "mailchimp.svg",
  zendesk: "zendesk.svg",
  microsoft: "microsoft.svg",
  plaid: "plaid.svg",
  docusign: "docusign.png",
};
